import z from "zod";

import type { SignupSource } from "../constants/signup-source";

export const UserCreatedEventSchema = z.object({
  userId: z.string(),
  createdAt: z.string().datetime(),
});

export type UserCreatedEvent = z.infer<typeof UserCreatedEventSchema>;

export type SignupAcquisitionProperties = {
  howTheyFoundUs: string | null;
  whoTheyAre: string | null;
  initialUtmSource: string | null;
  initialUtmMedium: string | null;
  initialUtmCampaign: string | null;
  initialUtmTerm: string | null;
  initialUtmContent: string | null;
  latestUtmSource: string | null;
  latestUtmMedium: string | null;
  latestUtmCampaign: string | null;
  initialReferrer: string | null;
  initialReferringDomain: string | null;
  latestReferrer: string | null;
  latestReferringDomain: string | null;
  googleAnalyticsClientId: string | null;
  googleAnalyticsSessionId: string | null;
  linkedInFatId: string | null;
  gclid: string | null;
  gadSource: string | null;
};

export type UserSignupNotificationUser = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  createdAt: Date;
  registrationMethod: string;
  authProvider: string | null;
};

export type UserSignupNotificationTeam = {
  id: string;
  name: string;
  slug: string;
  type: string;
  membershipRole: string;
};

export type UserSignupNotificationContext = {
  user: UserSignupNotificationUser;
  team: UserSignupNotificationTeam | null;
};

export type UserSignupAttribution = {
  gclid: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmTerm: string | null;
  utmContent: string | null;
  landingVariant: string | null;
  landingPageUrl: string | null;
  referrerUrl: string | null;
  signupSource: SignupSource | null;
};

export type HandleUserSignupNotificationInput = {
  event: UserCreatedEvent;
};

export type UserSignupNotificationLinks = {
  activityUrl: string;
  posthogPersonUrl: string;
};

export interface UserSignupNotificationServiceInterface {
  handleUserCreated(input: HandleUserSignupNotificationInput): Promise<void>;
}

export interface UserSignupGatorSyncServiceInterface {
  handleUserCreatedGatorSync(
    input: HandleUserSignupNotificationInput,
  ): Promise<void>;
}
